/**
 * The Lyrmo mark: looking down into a well. Three nested rounded squares, each deeper and
 * darker, sink toward the bottom like water seen from above. Colors come from the brand
 * palette in theme.css (public/favicon.svg repeats them, since it can't read CSS variables).
 */
export function BrandMark() {
  return (
    <svg viewBox="8 8 48 48" aria-hidden="true" focusable="false">
      <rect x="8" y="8" width="48" height="48" rx="16" style={{ fill: 'var(--brand-rim)' }} />
      <rect x="15" y="20" width="34" height="34" rx="11.5" style={{ fill: 'var(--brand-wall)' }} />
      <rect x="22" y="32" width="20" height="20" rx="7" style={{ fill: 'var(--brand-depth)' }} />
    </svg>
  );
}
